import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={13}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.36 7.764-5.042 8.733c-1.202 2.082-3.805.58-2.603-1.503l5.042-8.732C3.84 3.304 5.47.082 8.824.013l-.868 1.504C6.32 4.351 9.79 6.354 11.426 3.521l.868-1.504c1.775 3.337-.357 5.962-3.935 5.747ZM3.575 14.18l-.734 1.272c-.434.752-1.417.184-.983-.568l.734-1.272c.434-.752 1.418-.184.983.568Z"
      fill="#000"
    />
  </svg>
);

export default SvgComponent;
